'use strict';

namespace Core {

    class FlightBookingSummary {

        private trip: any;

        extrasCost: number;
        flight: any;
        flightCost: number;
        atolAvailable: boolean;
        atolCost: number;
        occupancy: any;
        totalCost: number;
        nights: number;
        carHireExtras: any;
        carHireExtrasTotal: number;
        extras: any;
        attractionsCost: string;

        constructor(
            private $q: ng.IQService,
            private $routeParams: any,
            private $scope: ng.IScope,
            private basketStore: any,
            private broker: Broker,
            private tripService: TripService,
            private occupancyService: any
        ) {
            tripService.getTrip($routeParams.tripId).then(trip => {
                if (trip && trip.BasketId) {
                    this.trip = trip;

                    tripService.getTripOccupancy(trip.TripId)
                    .then(results => {
                        this.occupancy = results[0];
                    });

                    this.getCostBreakdown();
                    this.updateFlightInfo();

                    broker.subscribe('FlightBookingSummary', 'basketUpdated', () => {
                        this.getCostBreakdown();
                        this.updateFlightInfo();
                    });

                    broker.subscribe('FlightBookingSummary', 'updatePricesOnPUP', e => {
                        this.getCostBreakdown();
                        this.updateFlightInfo();
                    });

                    $scope.$on('$destroy', () => {
                        broker.unsubscribe('FlightBookingSummary');
                    });
                }
            });
        }

        private getCostBreakdown(): void {

            this.$q.all([
                this.basketStore.totalCost(this.trip.BasketId),
                this.basketStore.costBreakdownGrouped(this.trip.BasketId),
                this.basketStore.carHire(this.trip.BasketId),
                this.basketStore.isAtolProtected(this.trip.BasketId),
                this.basketStore.attractionCost(this.trip.BasketId)
            ]).then(([
                totalCost,
                costBreakdownGrouped,
                carHire,
                isAtolProtected,
                attractionsCost
            ]) => {

                this.totalCost = parseFloat(totalCost);
                this.atolAvailable = isAtolProtected;
                this.attractionsCost = attractionsCost;

                _.each(costBreakdownGrouped, (cb) => {
                    if (cb.group === 2) {

                        // FLIGHTS
                        this.flightCost = cb.total;

                        const atol = _.find(cb.costBreakdown, (item: any) => {
                            return item.Description.indexOf('ATOL') >= 0;
                        });
                        if (atol) {
                            this.atolCost = atol.UnitAmount * atol.Quantity;
                            this.flightCost = cb.total - this.atolCost; // subtract the atol cost from the flights total
                        } else {
                            this.flightCost = cb.total;
                        }
                    } else if (cb.group === 3) {
                        // EXTRAS
                        this.extrasCost = cb.total;
                        this.extras = this.basketStore.extrasBreakdown(cb.costBreakdown);
                    }
                });

                let carHireExtras: any = _.get(carHire, 'RequestedItems');

                this.carHireExtras = carHireExtras;
                this.carHireExtrasTotal = carHireExtras ?
                    carHireExtras.reduce((total, extra) => total += extra.UnitAmount, 0) :
                    undefined;

            });

        }

        private updateFlightInfo(): void {
            this.basketStore.flight(this.trip.BasketId)
            .then(flight => {
                this.flight = flight;
                this.nights = this.flight.Details.Itinerary.Nights;
            });
        }

        public showDetails(e) {
            const passengers = this.occupancyService.getTotalPeopleCounts();
            e.preventDefault();
            this.broker.publish('showModalFlightDetails', { flight: this.flight.Details.Itinerary });
        }

    }

    angular
        .module('core')
        .directive('flightBookingSummary', (): ng.IDirective => {

        return {
            scope: {},
            restrict: 'E',
            bindToController: {
                cardFeeForTotal: '=?'
            },
            controller: FlightBookingSummary,
            controllerAs: 'fbs',
            replace: true,
            templateUrl: (element, attr) => {
                if(attr.templateVersion) {
                    return 'partials/booking/template?name=FlightBookingSummary&version='
                    + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=FlightBookingSummary';
            }
        };

    });

}
